"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Image = _interopRequireDefault(require("../../atoms/Image"));

var _Embed = _interopRequireDefault(require("../../atoms/Embed"));

require("./MenuFilesDisplay.css");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var MenuFilesDisplay = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MenuFilesDisplay, _React$Component);

  var _super = _createSuper(MenuFilesDisplay);

  function MenuFilesDisplay() {
    (0, _classCallCheck2["default"])(this, MenuFilesDisplay);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MenuFilesDisplay, [{
    key: "getTabPanes",
    value: function getTabPanes() {
      var files = this.props.files;
      return files.map(function (_ref, index) {
        var url = _ref.url,
            filename = _ref.filename;
        return {
          menuItem: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu.Item, null, /*#__PURE__*/_react["default"].createElement("h3", null, filename || "Menu ".concat(index + 1))),
          pane: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Tab.Pane, null, !url.includes('.pdf') && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
            src: url,
            fluid: true
          }), url.includes('.pdf') && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
            className: "desktop"
          }, /*#__PURE__*/_react["default"].createElement(_Embed["default"], {
            url: url,
            active: true
          })), /*#__PURE__*/_react["default"].createElement("div", {
            className: "mobile"
          }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
            as: "a",
            href: url,
            target: "_blank",
            primary: true,
            className: "mobile"
          }, "View ", filename || "Menu ".concat(index + 1)))))
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Tab, {
        className: "fm-menu-files-display",
        renderActiveOnly: false,
        menu: {
          style: {
            height: 'unset',
            overflowX: 'auto'
          },
          attached: true,
          tabular: true
        },
        panes: this.getTabPanes()
      });
    }
  }]);
  return MenuFilesDisplay;
}(_react["default"].Component);

exports["default"] = MenuFilesDisplay;
MenuFilesDisplay.propTypes = {
  files: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    url: _propTypes["default"].string,
    filename: _propTypes["default"].string
  })).isRequired
};
MenuFilesDisplay.defaultProps = {};